module.exports = __webpack_public_path__ + "static/media/analise_livrarias.60068073.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/analise_livrarias.svg
// module id = 1288
// module chunks = 0